import React from 'react';
import { bool, func, number, string } from 'prop-types';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { useState } from 'react';

import { requiredFieldArrayCheckbox } from '../../../util/validators';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { numberAtLeast, required } from '../../../util/validators';
import { PURCHASE_PROCESS_NAME } from '../../../transactions/transaction';

import {
  Form,
  FieldSelect,
  FieldTextInput,
  InlineTextButton,
  PrimaryButton,
  FieldCheckboxGroup,
  H3,
  H6,
  FieldCurrencyInput,
} from '../../../components';

import EstimatedCustomerBreakdownMaybe from '../EstimatedCustomerBreakdownMaybe';

import css from './ProductOrderForm.module.css';
import appSettings from '../../../config/settings';
import { useConfiguration } from '../../../context/configurationContext';
import TipModal from '../../../containers/ListingPage/TipModal/TipModal';
import arrayMutators from 'final-form-arrays';
import BeneficiaryInfoField from '../BeneficiaryInfoField/BeneficiaryInfoField';

let debounceTimer;

// Browsers can't render huge number of select options.
// (stock is shown inside select element)
// Note: input element could allow ordering bigger quantities
const MAX_QUANTITY_FOR_DROPDOWN = 100;

const renderForm = formRenderProps => {
  const {
    // FormRenderProps from final-form
    handleSubmit,
    form: formApi,
    form: {
      mutators: { push },
    },
    // Custom props passed to the form component
    intl,
    formId,
    currentStock,
    hasMultipleDeliveryMethods,
    listingId,
    isOwnListing,
    onFetchTransactionLineItems,
    onContactUser,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    price,
    marketplaceName,
    values,
    listing,
    tippingAllowed,
    author,
  } = formRenderProps;

  //TODO User later when creating product type listings
  const isFixedPriceListing = false; //listing?.attributes?.publicData?.donationType === 'fixed';
  const handleOnChange = formValues => {

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {

      const collectBeneficiaryInfo =
        Array.isArray(listing?.attributes?.publicData?.collectBeneficiaryInfo) &&
        listing?.attributes?.publicData?.collectBeneficiaryInfo[0];

      // refresh formValues.values
      const values1 = formApi.getState().values;
      if (collectBeneficiaryInfo && (!values1?.beneficiaryInfo || (values1?.beneficiaryInfo.length > 0 && values1?.beneficiaryInfo[0] != undefined && Object.keys(values1?.beneficiaryInfo[0]).length ==0))) {
        formApi.change('beneficiaryInfo', [undefined]);
      }


      const oldDonationPrice = values?.donationPrice;
      const { quantity, deliveryMethod, donationPrice, tip, terms } = formValues.values;


      //if (terms !== undefined) {
      //  return;
      //}

      const stockReservationQuantity = Number.parseInt(quantity, 10);
      const isBrowser = typeof window !== 'undefined';
      const checkForDonationPrice = isFixedPriceListing || donationPrice;
      // const collectBeneficiaryInfo =
      //   Array.isArray(listing?.attributes?.publicData?.collectBeneficiaryInfo) &&
      //   listing?.attributes?.publicData?.collectBeneficiaryInfo[0]
        //&& Object.keys(values?.beneficiaryInfo).length >0;
      if (
        isBrowser &&
        stockReservationQuantity &&
        !fetchLineItemsInProgress &&
        checkForDonationPrice &&
        ((oldDonationPrice?.amount !== donationPrice?.amount) || (tip?.amount >=0))
        //&& values?.beneficiaryInfo
      ) {


//|| Object.keys(values?.beneficiaryInfo).length === 0
        if (collectBeneficiaryInfo && !values?.beneficiaryInfo) {
          formApi.change('beneficiaryInfo', [undefined]);
        }

        return onFetchTransactionLineItems({
          orderData: { stockReservationQuantity, deliveryMethod, donationPrice, tip },
          listingId,
          isOwnListing,
        });
      }
    }, 700);
  };

  // In case quantity and deliveryMethod are missing focus on that select-input.
  // Otherwise continue with the default handleSubmit function.
  const handleFormSubmit = e => {
    const { quantity, deliveryMethod } = values || {};

    if (values?.beneficiaryInfo && Object.keys(values?.beneficiaryInfo[0]).length === 0)
    {
      // handle the case then the user deleted after beneficiary info
      e.preventDefault();
      // formApi.blur('beneficiaryInfo[0].firstName');
      // formApi.focus('beneficiaryInfo[0].firstName');
      return;
    }

    if (!quantity || quantity < 1) {
      e.preventDefault();
      // Blur event will show validator message
      formApi.blur('quantity');
      formApi.focus('quantity');
    }
    // else if (!deliveryMethod) {
    //   e.preventDefault();
    //   // Blur event will show validator message
    //   formApi.blur('deliveryMethod');
    //   formApi.focus('deliveryMethod');
    // }
    else {
      handleSubmit(e);
    }
  };

  const breakdownData = {};
  const showBreakdown =
    breakdownData && lineItems && !fetchLineItemsError;
  const breakdown = showBreakdown ? (
    <div className={css.breakdownWrapper}>
      <H6 as="h3" className={css.bookingBreakdownTitle}>
        <FormattedMessage id="ProductOrderForm.breakdownTitle" />
      </H6>
      <hr className={css.totalDivider} />
      <EstimatedCustomerBreakdownMaybe
        breakdownData={breakdownData}
        lineItems={lineItems}
        currency={price.currency}
        marketplaceName={marketplaceName}
        processName={PURCHASE_PROCESS_NAME}
        donateDOM={(
          <div className={css.actionLinks}>
            <p className={css.link} onClick={() => setWhyDonateModalOpen(true)}>
              <FormattedMessage id="TipModal.whyDonate" />
            </p>
            <p className={css.separator}>•</p>
            <p className={css.link} onClick={() => setChangeModalOpen(true)}>
              <FormattedMessage id="TipModal.change" />
            </p>
          </div>
        )}
      />
    </div>
  ) : null;

  const showContactUser = typeof onContactUser === 'function';

  const onClickContactUser = e => {
    e.preventDefault();
    onContactUser();
  };

  const contactSellerLink = (
    <InlineTextButton onClick={onClickContactUser}>
      <FormattedMessage id="ProductOrderForm.finePrintNoStockLinkText" />
    </InlineTextButton>
  );
  const quantityRequiredMsg = intl.formatMessage({ id: 'ProductOrderForm.quantityRequired' });

  const hasStock = currentStock && currentStock > 0;
  const selectableStock =
    currentStock > MAX_QUANTITY_FOR_DROPDOWN ? MAX_QUANTITY_FOR_DROPDOWN : currentStock;
  const quantities = hasStock ? [...Array(selectableStock).keys()].map(i => i + 1) : [];
  const hasNoStockLeft = typeof currentStock != null && currentStock === 0;
  const hasOneItemLeft = typeof currentStock != null && currentStock === 1;
  const submitDisabled = !hasStock;
  const config = useConfiguration();
  const collectBeneficiaryInfo =
    Array.isArray(listing?.attributes?.publicData?.collectBeneficiaryInfo) &&
    listing?.attributes?.publicData?.collectBeneficiaryInfo[0];
  const noBeneficiaryInfoAdded =
    collectBeneficiaryInfo &&
    ((Array.isArray(values?.beneficiaryInfo) && !values?.beneficiaryInfo[0])
    || typeof values?.beneficiaryInfo === 'undefined');

  //const beneficiaryInfoAdded = !noBeneficiaryInfoAdded;

  const tosAccepted = values?.terms?.includes('terms-and-conditions');

  const checkBeneficiaryInfoAdded = () => {
    if (collectBeneficiaryInfo) {
      if (typeof values?.beneficiaryInfo === 'undefined') {
        return true;
      }

      if (Array.isArray(values?.beneficiaryInfo)) {
        const allField = values?.beneficiaryInfo.every((item) => item && item.class && item.firstName && item.lastName);

        return !allField;
      }
    }

    return false;
  };

  const termsSalesLink = (
    // add a link which open target in a new t
    <a href='https://asso.jaikan.com/p/terms-and-conditions' target='_blank'  >
      <FormattedMessage id="AuthenticationPage.termsAndConditionsSalesLinkText" />
    </a>
  );

  const [changeModalOpen, setChangeModalOpen] = useState(false);
  const [whyDonateModalOpen, setWhyDonateModalOpen] = useState(false);

  const closeChangeModal = () => {
    setChangeModalOpen(false);
  };

  const closeWhyDonateModal = () => {
    setWhyDonateModalOpen(false);
  };

  const isThereTip = () => {
    if (lineItems) {
      const tipObj = lineItems.find(({ code }) => code === 'line-item/tip');

      if (tipObj) {
        if (tipObj?.lineTotal?.amount !== 0) {
          return true
        }
      }
    }

    return false;
  };

  const isCheckAgree = () => {
    const agreeToContribute = values?.agreeToContribute?.includes('agree-to-contribute');
    const hasTip = isThereTip();

    if (hasTip && !agreeToContribute) {
      return true;
    }

    return false;
  };

  return (
    <Form onSubmit={handleFormSubmit}>
      <FormSpy subscription={{ values: true }} onChange={handleOnChange} />

      {hasNoStockLeft ? null : hasOneItemLeft ? (
        <FieldTextInput
          id={`${formId}.quantity`}
          className={css.quantityField}
          name="quantity"
          type="hidden"
          validate={numberAtLeast(quantityRequiredMsg, 1)}
        />
      ) : (
        <FieldSelect
          id={`${formId}.quantity`}
          className={css.quantityField}
          name="quantity"
          disabled={!hasStock}
          label={intl.formatMessage({ id: 'ProductOrderForm.quantityLabel' })}
          validate={numberAtLeast(quantityRequiredMsg, 1)}
        >
          <option disabled value="">
            {intl.formatMessage({ id: 'ProductOrderForm.selectQuantityOption' })}
          </option>
          {quantities.map(quantity => (
            <option key={quantity} value={quantity}>
              {intl.formatMessage({ id: 'ProductOrderForm.quantityOption' }, { quantity })}
            </option>
          ))}
        </FieldSelect>
      )}

      {/* {hasNoStockLeft ? null : hasMultipleDeliveryMethods ? (
        <FieldSelect
          id={`${formId}.deliveryMethod`}
          className={css.deliveryField}
          name="deliveryMethod"
          disabled={!hasStock}
          label={intl.formatMessage({ id: 'ProductOrderForm.deliveryMethodLabel' })}
          validate={required(intl.formatMessage({ id: 'ProductOrderForm.deliveryMethodRequired' }))}
        >
          <option disabled value="">
            {intl.formatMessage({ id: 'ProductOrderForm.selectDeliveryMethodOption' })}
          </option>
          <option value={'pickup'}>
            {intl.formatMessage({ id: 'ProductOrderForm.pickupOption' })}
          </option>
          <option value={'shipping'}>
            {intl.formatMessage({ id: 'ProductOrderForm.shippingOption' })}
          </option>
        </FieldSelect>
      ) : (
        <div className={css.deliveryField}>
          <H3 rootClassName={css.singleDeliveryMethodLabel}>
            {intl.formatMessage({ id: 'ProductOrderForm.deliveryMethodLabel' })}
          </H3>
          <p className={css.singleDeliveryMethodSelected}>
            {values.deliveryMethod === 'shipping'
              ? intl.formatMessage({ id: 'ProductOrderForm.shippingOption' })
              : intl.formatMessage({ id: 'ProductOrderForm.pickupOption' })}
          </p>
          <FieldTextInput
            id={`${formId}.deliveryMethod`}
            className={css.deliveryField}
            name="deliveryMethod"
            type="hidden"
          />
        </div>
      )} */}

      {!isFixedPriceListing && (
        <FieldCurrencyInput
          id={`${formId}donationPrice`}
          name="donationPrice"
          className={css.donationAmountInput}
          label={intl.formatMessage({ id: 'ProductOrderForm.donationAmount' })}
          placeholder={intl.formatMessage({ id: 'EditListingPricingForm.priceInputPlaceholder' })}
          currencyConfig={appSettings.getCurrencyFormatting(config.currency)}
          // validate={priceValidators}
        />
      )}
      {listing?.attributes?.publicData?.suggestedAmountInfo && (
        <p className={css.suggestedAmountInfo}>
          {listing?.attributes?.publicData?.suggestedAmountInfo}
        </p>
      )}

      {tippingAllowed && (
        <FieldCurrencyInput
          id={`${formId}tip`}
          name="tip"
          className={`${css.donationAmountInput} ${css.hiddenField}`}
          label={intl.formatMessage({ id: 'ProductOrderForm.tipAmount' })}
          placeholder={intl.formatMessage({ id: 'EditListingPricingForm.priceInputPlaceholder' })}
          currencyConfig={appSettings.getCurrencyFormatting(config.currency)}
          // validate={priceValidators}
        />
      )}

      {breakdown}

      {showBreakdown && collectBeneficiaryInfo && <BeneficiaryInfoField push={push} author={author} />}

      {showBreakdown && <TipModal
          formApi={formApi}
          lineItems={lineItems}
          isOpenChange={changeModalOpen}
          isOpenWhy={whyDonateModalOpen}
          onCloseChange={closeChangeModal}
          onCloseWhy={closeWhyDonateModal}
          intl={intl} />}

      <div className={css.checkboxPadding}>
        <FieldCheckboxGroup
          name="terms"
          id="terms-accepted"
          optionLabelClassName={css.finePrint}
          options={[
            {
              key: 'terms-and-conditions',
              label: intl.formatMessage(
                { id: 'AuthenticationPage.termsAcceptText' },
                { termsSalesLink }
              ),
            },
          ]}
          validate={requiredFieldArrayCheckbox(
            intl.formatMessage({ id: 'AuthenticationPage.termsAndConditionsAcceptRequired' })
          )}
        />

        {
          isThereTip() ? (
            <FieldCheckboxGroup
              name="agreeToContribute"
              id="agree-to-contribute"
              optionLabelClassName={css.finePrint}
              options={[
                {
                  key: 'agree-to-contribute',
                  label: intl.formatMessage(
                    { id: 'AuthenticationPage.agreeToContribute' },
                  ),
                },
              ]}
            />
          ) : null
        }
      </div>

      <div className={css.submitButton}>
        <PrimaryButton
          type="submit"
          inProgress={fetchLineItemsInProgress}
          disabled={submitDisabled || checkBeneficiaryInfoAdded() || !tosAccepted || isCheckAgree()}
        >
          {hasStock ? (
            <FormattedMessage id="ProductOrderForm.ctaButton" />
          ) : (
            <FormattedMessage id="ProductOrderForm.ctaButtonNoStock" />
          )}
        </PrimaryButton>
      </div>
      <p className={`${css.finePrint} ${css.checkboxPadding}`}>
        {hasStock ? (
          <FormattedMessage id="ProductOrderForm.finePrint" />
        ) : showContactUser ? (
          <FormattedMessage id="ProductOrderForm.finePrintNoStock" values={{ contactSellerLink }} />
        ) : null}
      </p>
    </Form>
  );
};

const ProductOrderFormTipping = props => {
  const intl = useIntl();
  const { price, currentStock, pickupEnabled, shippingEnabled } = props;


  // Should not happen for listings that go through EditListingWizard.
  // However, this might happen for imported listings.
  // if (!pickupEnabled && !shippingEnabled) {
  //   return (
  //     <p className={css.error}>
  //       <FormattedMessage id="ProductOrderForm.noDeliveryMethodSet" />
  //     </p>
  //   );
  // }

  const hasOneItemLeft = currentStock && currentStock === 1;
  const quantityMaybe = hasOneItemLeft ? { quantity: '1' } : {};
  const singleDeliveryMethodAvailableMaybe =
    shippingEnabled && !pickupEnabled
      ? { deliveryMethod: 'shipping' }
      : !shippingEnabled && pickupEnabled
      ? { deliveryMethod: 'pickup' }
      : {};
  const hasMultipleDeliveryMethods = pickupEnabled && shippingEnabled;
  const initialValues = {
    ...quantityMaybe,
    ...singleDeliveryMethodAvailableMaybe,
  };

  return (
    <FinalForm
      initialValues={initialValues}
      hasMultipleDeliveryMethods={hasMultipleDeliveryMethods}
      mutators={{ ...arrayMutators }}
      {...props}
      intl={intl}
      render={renderForm}
    />
  );
};

ProductOrderFormTipping.defaultProps = {
  rootClassName: null,
  className: null,
  price: null,
  currentStock: null,
  listingId: null,
  isOwnListing: false,
  lineItems: null,
  fetchLineItemsError: null,
};

ProductOrderFormTipping.propTypes = {
  rootClassName: string,
  className: string,

  marketplaceName: string.isRequired,

  // form
  formId: string.isRequired,
  onSubmit: func.isRequired,

  // listing
  listingId: propTypes.uuid,
  price: propTypes.money,
  currentStock: number,
  isOwnListing: bool,

  // line items
  lineItems: propTypes.lineItems,
  onFetchTransactionLineItems: func.isRequired,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // other
  onContactUser: func,
};

export default ProductOrderFormTipping;
